<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-02-10 11:40:00
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-04-13 16:47:05
 * @FilePath: \goodmanger\src\views\GoodsManagement.vue
 * @Description: 商品管理页面
-->
<template>
  <div class="goods-management">
    <div class="page-header">
      <h2>商品管理</h2>
      <el-button type="primary" @click="handleAddGoods">添加商品</el-button>
    </div>
    
    <div class="search-box">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="商品名称">
          <el-input v-model="searchForm.name" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="商品分类">
          <el-select v-model="searchForm.category" placeholder="请选择商品分类" @change="handleCategoryChange">
               <el-option label="全部" value=""></el-option>
               <el-option :label="item.commodity_type" :value="item.commodity_type" v-for="item in goodstypeList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <el-table :data="goodsList" style="width: 100%" height="350">
    
      <el-table-column prop="commodity_pic" label="商品图片">
          
        <template slot-scope="scope">
          <el-image
      style="width: 30px; height: 30px"
      :src="scope.row.commodity_pic"
      :fit="'fill'"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="commodity_name" label="商品名称"></el-table-column>
      <el-table-column prop="commodity_type" label="商品分类"></el-table-column>
      <el-table-column prop="commodity_sf" label="商品规格"></el-table-column>
      <el-table-column prop="commodity_price" label="商品价格"></el-table-column>
      <el-table-column prop="commodity_stock" label="商品库存"></el-table-column>
      
      <el-table-column prop="status" label="状态" width="100">
        <template >
          <el-tag :type="'success'">
         在售
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button type="primary" size="small" @click="handleEditGoods(scope.row)">编辑</el-button> -->
          <el-button type="danger" size="small" @click="handleDeleteGoods(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    
    <!-- 添加/编辑商品对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px">
   
      <el-form :model="goodsForm" :rules="rules" ref="goodsForm">
        
        <el-form-item label="商品图片" prop="commodity_pic">
          <div class="image-upload-container">
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :show-file-list="false"
              :on-success="handleImageUploadSuccess"
              :on-error="handleImageUploadError"
              :before-upload="beforeImageUpload"
              auto-upload
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="image-list">
              <div 
                v-for="(img, index) in imageFiles" 
                :key="index" 
                class="image-item"
              >
                <el-image :src="img.url" class="image-preview"></el-image>
                <el-button 
                  type="danger" 
                  size="mini" 
                  class="image-delete-btn"
                  @click="removeImage(index)"
                >
                  删除
                </el-button>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="商品名称" prop="name">
          <el-input v-model="goodsForm.name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="商品分类" prop="category">
          <el-select v-model="goodsForm.category" placeholder="请选择商品分类" size="small">
            <el-option :label="item.commodity_type" :value="item.commodity_type" v-for="item in goodstypeList" :key="item.id"></el-option>
         
          </el-select>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input type="number" v-model="goodsForm.price" min="0" size="small"></el-input>
        </el-form-item>
        <el-form-item label="库存" prop="stock">
          <el-input type="number" v-model="goodsForm.stock" min="0" size="small"></el-input>
        </el-form-item>
        <el-form-item label="规格" prop="commodity_sf">
          <el-input v-model="goodsForm.commodity_sf" size="small"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="commodity_back">
          <el-input type="textarea" v-model="goodsForm.commodity_back" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'GoodsManagement',
  data() {
    return {
      getimgUrl:'',
      uploadUrl: 'https://www.moodsci.com/pigbox/CommodityService/uploadGoodsPicture',
      imageUrl:'',
      goodstypeList:[],
      activeMenu: '/goods-management',
      searchForm: {
        name: '',
        category: ''
      },
      goodsList: [
       
      ],
      oldGoodsList: [],
      currentPage: 1,
      pageSize: 10,
      total: 3,
      dialogVisible: false,
      dialogTitle: '添加商品',
      goodsForm: {
        id: '',
        name: '',
        category: '',
        price: '',
        stock: '',
        status: 'active',
        commodity_sf: '',
        commodity_back: '',
        commodity_pic: ''
      },
      imageFiles: [],
      rules: {
        // commodity_pic: [
        //   { required: true, message: '请上传商品图片', trigger: 'change' }
        // ],
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择商品分类', trigger: 'change' }
        ]
      }
    }
  },
  mounted(){
    this.getGoodsType()
    this.getGoodsData()
  },
  methods: {
    getGoodsData(){
       axios.get("https://www.moodsci.com/pigbox/CommodityService/queryJianZuGoodsInfo").then((res)=>{
            console.log(res.data);
            this.goodsList= res.data
            this.oldGoodsList= res.data
        })
    },
    getGoodsType(){
        axios.get("https://www.moodsci.com/pigbox/CommodityService/queryJianZuGoodsType").then((res)=>{
            console.log(res.data);
            this.goodstypeList= res.data
        })
    },
    handleSearch() {
      // 搜索逻辑
      console.log('搜索商品:', this.searchForm);
      
      // 构建搜索关键字
      let searchText = this.searchForm.name;
      
      // 调用搜索接口
      const apiUrl = `https://www.moodsci.com/pigbox/CommodityService/searchJianZuGoods?text=${encodeURIComponent(searchText)}`;
      
      axios.post(apiUrl)
        .then(response => {
          console.log('搜索接口响应:', response);
          // 更新商品列表和总数
          if (response.data) {
            this.goodsList = response.data;
            this.total = response.data.length;
            this.oldGoodsList = response.data;
            // 应用分类过滤
            this.applyCategoryFilter();
          } else {
            this.goodsList = [];
            this.total = 0;
          }
        })
        .catch(error => {
          console.error('搜索接口调用失败:', error);
          this.$message({ type: 'error', message: '搜索失败，请重试' });
        });
    },
    handleCategoryChange() {
      // 分类切换逻辑
      console.log('切换商品分类:', this.searchForm.category);
      // 应用分类过滤
      this.applyCategoryFilter();
    },
    applyCategoryFilter() {
      // 应用分类过滤
      if (this.searchForm.category) {
        // 从服务器获取最新的商品数据
      
            let filteredList = this.oldGoodsList;
            
            // 应用搜索过滤
            if (this.searchForm.name) {
              const searchName = this.searchForm.name.toLowerCase();
              filteredList = filteredList.filter(item => 
                item.commodity_name.toLowerCase().includes(searchName)
              );
            }
            
            // 应用分类过滤
            filteredList = filteredList.filter(item => 
              item.commodity_type === this.searchForm.category
            );
            
            // 更新商品列表和总数
            this.goodsList = filteredList;
            this.total = filteredList.length;
        
      } else {
        // 如果选择了"全部"，则重新加载所有商品数据
        // this.getGoodsData();
        this.goodsList = this.oldGoodsList;
      }
    },
    resetForm() {
      this.searchForm = {
        name: '',
        category: ''
      };
      // 重置表单后重新加载所有商品数据
      this.getGoodsData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      console.log(`每页 ${size} 条`);
    },
    handleCurrentChange(current) {
      this.currentPage = current;
      console.log(`当前页: ${current}`);
    },
    handleAddGoods() {
      this.dialogTitle = '添加商品';
      this.goodsForm = {
        id: '',
        name: '',
        category: '',
        price: '',
        stock: '',
        status: 'active',
        commodity_sf: '',
        commodity_back: '',
        commodity_pic: ''
      };
      this.imageFiles = [];
      this.dialogVisible = true;
    },
    handleEditGoods(row) {
      this.dialogTitle = '编辑商品';
      this.getimgUrl = row.commodity_pic
      this.goodsForm = {
        id: row.id,
        name: row.commodity_name,
        category: row.commodity_type,
        price: row.commodity_price,
        stock: row.commodity_stock,
        commodity_sf: row.commodity_sf,
        commodity_back: row.commodity_back,
        commodity_pic: row.commodity_pic
      };
      if (row.commodity_pic) {
        this.imageFiles = [{ url: row.commodity_pic }];
      } else {
        this.imageFiles = [];
      }
      this.dialogVisible = true;
    },
    handleDeleteGoods(id) {
      this.$confirm('确定要删除此商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除商品 - 调用接口
        const apiUrl = `https://www.moodsci.com/pigbox/CommodityService/deteleJianZuGoods/${id}`;
        
        axios.post(apiUrl)
          .then(response => {
            console.log('删除商品接口响应:', response);
            // 接口调用成功后，更新本地数据
            this.goodsList = this.goodsList.filter(item => item.id !== id);
            this.total = this.goodsList.length;
            this.$message({ type: 'success', message: '删除成功' });
          })
          .catch(error => {
            console.error('删除商品接口调用失败:', error);
            this.$message({ type: 'error', message: '删除失败，请重试' });
          });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
    // 图片上传成功回调
    handleImageUploadSuccess(response, file) {
      console.log('图片上传成功:', response);
      console.log('response类型:', typeof response);
      console.log('response结构:', JSON.stringify(response));
      
      // 尝试处理不同格式的response
      let imageUrl = '';
      if (typeof response === 'string') {
        imageUrl = response;
      } else if (response.url) {
        imageUrl = response.url;
      } else if (response.data && response.data.url) {
        imageUrl = response.data.url;
      }
      
      if (imageUrl && !imageUrl.startsWith('http')) {
        imageUrl = 'https://www.moodsci.com' + imageUrl;
      }
      
      console.log('最终图片URL:', imageUrl);
      
      if (imageUrl) {
        this.imageFiles.push({
          url: imageUrl,
          raw: file
        });
        this.goodsForm.commodity_pic = imageUrl;
        this.$message({ type: 'success', message: '图片上传成功' });
      }
    },
    // 图片上传失败回调
    handleImageUploadError(err) {
      console.error('图片上传失败:', err);
      this.$message({ type: 'error', message: '图片上传失败，请重试' });
    },
    removeImage(index) {
      this.imageFiles.splice(index, 1);
      if (this.imageFiles.length > 0) {
        this.goodsForm.commodity_pic = this.imageFiles[this.imageFiles.length - 1].url;
      } else {
        this.goodsForm.commodity_pic = '';
      }
    },
    // 图片上传前校验
    beforeImageUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isJPG) {
        this.$message.error('只能上传JPG/PNG图片!');
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB!');
      }
      
      return isJPG && isLt2M;
    },
    handleSubmit() {
      this.$refs.goodsForm.validate((valid) => {
        if (valid) {
          const imageUrls = this.imageFiles.map(img => img.url).join(',');
          if (this.goodsForm.id) {
            const apiUrl = 'https://www.moodsci.com/pigbox/CommodityService/updateJianZuGoodsType';
            const params = {
              id: this.goodsForm.id,
              goods: [
                {
                  commodity_back: this.goodsForm.commodity_back,
                  commodity_name: this.goodsForm.name,
                  commodity_pic: imageUrls,
                  commodity_price: this.goodsForm.price,
                  commodity_sf: this.goodsForm.commodity_sf,
                  commodity_stock: this.goodsForm.stock,
                  commodity_type: this.goodsForm.category
                }
              ]
            };
            
            axios.post(apiUrl, params)
              .then(response => {
                console.log('编辑商品接口响应:', response);
                const index = this.goodsList.findIndex(item => item.id === this.goodsForm.id);
                if (index !== -1) {
                  this.goodsList.splice(index, 1, { ...this.goodsForm, commodity_pic: imageUrls });
                }
                this.dialogVisible = false;
                this.$message({ type: 'success', message: '编辑成功' });
              })
              .catch(error => {
                console.error('编辑商品接口调用失败:', error);
                this.$message({ type: 'error', message: '编辑失败，请重试' });
              });
          } else {
            const apiUrl = 'https://www.moodsci.com/pigbox/CommodityService/ImportJianZuGoods';
            const params = [
              {
                commodity_back: this.goodsForm.commodity_back,
                commodity_name: this.goodsForm.name,
                commodity_pic: imageUrls,
                commodity_price: this.goodsForm.price,
                commodity_sf: this.goodsForm.commodity_sf,
                commodity_stock: this.goodsForm.stock,
                commodity_type: this.goodsForm.category
              }
            ];
            
            axios.post(apiUrl, params)
              .then(response => {
                console.log('接口响应:', response);
                const newGoods = {
                  ...this.goodsForm,
                  id: this.goodsList.length + 1,
                  commodity_pic: imageUrls
                };
                this.goodsList.push(newGoods);
                this.total = this.goodsList.length;
                this.dialogVisible = false;
                this.$message({ type: 'success', message: '添加成功' });
              })
              .catch(error => {
                console.error('接口调用失败:', error);
                this.$message({ type: 'error', message: '添加失败，请重试' });
              });
          }
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.goods-management {
  padding: 20px;
  background-color: #f5f5f5;
  height: 100%;
  overflow-y: auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
}

.search-box {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.el-table {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* 图片上传样式 */
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all .3s;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 20px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.image-upload-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.image-item {
  position: relative;
  display: inline-block;
}

.image-preview {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

.image-delete-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  padding: 4px 6px;
  font-size: 12px;
}
</style>